import { useEffect, useState, useContext, createContext } from 'react'

import type { ConfigFile } from './runtime'
import { getLoaderPromiseIfExists } from './runtime'

const AppConfigurationContext = createContext<ConfigFile | undefined>(undefined)

const { Provider: AppConfigurationProvider } = AppConfigurationContext

export function useConfig(): ConfigFile {
	const config = useContext(AppConfigurationContext)

	if (!config) {
		throw new Error('App not configured')
	}

	return config
}

export function useConfigLoader(): ConfigFile | undefined {
	const [config, setConfig] = useState<ConfigFile>()

	useEffect(() => {
		getLoaderPromiseIfExists().then((response) => {
			setConfig(response)
		})
	}, [])

	return config
}

export { AppConfigurationProvider }
